export default __webpack_public_path__ + "static/media/maarava_wide_icon.fb4a2d59.jpg";